// Voyage-only picker for Solo runs. Captain + Ship come from your Profile;
// only the voyage changes per-run (it's the strategic flavor of each
// expedition). Tap a voyage card and the run starts.
import { api } from '../api/client';
import { captainArt, shipArt, voyageIcon } from './art';
export async function openRunBuilder() {
    const overlay = document.createElement('div');
    overlay.className = 'help-overlay run-builder-overlay';
    overlay.innerHTML = `
    <div class="help-panel run-builder-panel" role="dialog" aria-label="Start a Solo Run">
      <button class="help-close" aria-label="Close">✕</button>
      <h2>Solo Run <span class="muted">— pick your voyage</span></h2>
      <div class="rb-loading">Loading…</div>
    </div>
  `;
    overlay.querySelector('.help-close')?.addEventListener('click', () => overlay.remove());
    overlay.addEventListener('click', (e) => { if (e.target === overlay)
        overlay.remove(); });
    document.body.appendChild(overlay);
    let prog, profile;
    try {
        [prog, profile] = await Promise.all([api.progression(), api.getProfile()]);
    }
    catch (err) {
        overlay.querySelector('.rb-loading').textContent = `Failed to load: ${err.message}`;
        return;
    }
    const voyageNames = new Map(prog.voyages.map((v) => [v.id, v.name]));
    const captain = prog.captains.find((c) => c.id === profile.pref_captain_id) ?? prog.captains[0];
    const ship = prog.ships.find((s) => s.id === profile.pref_ship_id) ?? prog.ships[0];
    const panel = overlay.querySelector('.help-panel');
    panel.innerHTML = `
    <button class="help-close" aria-label="Close">✕</button>
    <h2>Solo Run <span class="muted">— pick your voyage</span></h2>
    <div class="run-builder">
      <section class="rb-loadout">
        <div class="rb-loadout-art">
          <div class="rb-art rb-art--captain rb-loadout-captain">${captainArt(captain.id)}</div>
          <div class="rb-art rb-art--ship rb-loadout-ship">${shipArt(ship.id)}</div>
        </div>
        <div class="rb-loadout-text">
          <div class="rb-loadout-label">Sailing as</div>
          <div class="rb-loadout-pick"><strong>${escape(captain.name)}</strong> · <strong>${escape(ship.name)}</strong></div>
          <button class="rb-loadout-edit" type="button" id="rb-go-profile">Change loadout in Profile →</button>
        </div>
      </section>
      <section>
        <h3>Voyage</h3>
        <div class="rb-grid" data-pick="voyage">
          ${prog.voyages.map((v) => voyageCard(v, voyageNames)).join('')}
        </div>
      </section>
    </div>
  `;
    panel.querySelector('.help-close')?.addEventListener('click', () => overlay.remove());
    panel.querySelector('#rb-go-profile')?.addEventListener('click', () => {
        overlay.remove();
        window.location.hash = '#/profile';
    });
    // Tapping any unlocked voyage card immediately starts the run with it.
    panel.querySelectorAll('.rb-card.unlocked[data-kind="voyage"]').forEach((el) => {
        el.addEventListener('click', async () => {
            const voyageId = el.dataset.id;
            el.classList.add('selected');
            try {
                const created = await api.createPveMatch({
                    captain_id: captain.id,
                    ship_id: ship.id,
                    voyage_id: voyageId,
                });
                overlay.remove();
                window.location.hash = `#/match/${created.match_id}`;
            }
            catch (err) {
                alert(err.message);
            }
        });
    });
}
function voyageUnlockText(v, voyageNames) {
    if (v.unlock_after_voyage) {
        const prev = voyageNames.get(v.unlock_after_voyage) ?? v.unlock_after_voyage;
        return `Complete: ${prev}`;
    }
    return '';
}
function voyageCard(v, voyageNames) {
    const lockedTag = v.unlocked ? '' : `<span class="rb-lock">🔒 ${escape(voyageUnlockText(v, voyageNames))}</span>`;
    return `
    <div class="rb-card rb-card--portrait ${v.unlocked ? 'unlocked' : 'locked'}" data-kind="voyage" data-id="${v.id}">
      <div class="rb-art rb-art--voyage">${voyageIcon(v.id)}</div>
      <strong>${escape(v.name)}</strong>
      <p>${escape(v.description)}</p>
      ${lockedTag}
    </div>`;
}
function escape(s) {
    return s.replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
}
